<template>
    <div class="lottery-page">
        <div class="lottery-main">
            <div class="lottery-container">
                <!--中奖率 100% , 与朋友一起惊喜开盒-->
                <div class="header-top">
                    <van-icon @click="goAppBack" :name="isDirection ? 'arrow' : 'arrow-left'" />
                    <span class="share-btn" @click="goInvite">{{ $t('300145') }}</span>
                </div>
                <div class="lottery-top">
                    <h1 class="bold h-title" v-html="$t('300125')"></h1>
                    <p class="block">{{ $t("300142") }}: {{ parseTime(startTime, "{y}-{m}-{d}") }} ~
                        {{ parseTime(endTime, "{y}-{m}-{d}") }}</p>
                </div>
                <div class="lottery-box flex-between">
                    <div class="lottery-box-list relative">
                        <div class="lotteryMask" @click="handleOpenBlindBox"></div>
                        <div class="warn-message absolute" v-show="warnMessage">
                            <span class="inline-block"><i class="icon-tishi-2 iconfont inline-block"></i>&nbsp;&nbsp;{{ warnMessage }}</span>
                        </div>
                        <div class="buttons absolute flex-center">
                            <!--开启盲盒-->
                            <van-button v-if="!isDisabled" :disabled="isDisabled" class="form-btn open-btn" @click="handleOpenBlindBox">{{ $t("300127") }}
                            </van-button>
                            <van-button v-if="isDisabled" :disabled="isDisabled" class="form-btn open-btn disabel">{{$t("300127")}}</van-button>
                        </div>
                        <div class="lottery-item">
                            <div class="lottery-tab">
                                <div :class="{active:active == 'left'}" @click="changeTab('left')">{{$t('300128')}}</div>
                                <div :class="{active:active == 'right'}" @click="changeTab('right')">{{$t('300079')}}</div>
                            </div>
                            <!-- <div class="lottery-tab">
                <div  :class="{activeline:active == 'left'}" @click="changeTab('left')"></div>
                <div :class="{activeline:active == 'right'}" @click="changeTab('right')"></div>
              </div> -->
                            <!-- <van-tabs color="#ffc72b" title-active-color="#ffc72b" title-inactive-color="#fff" v-model="active">
                <van-tab name="max" :title="$t('300128')"> -->
                            <div v-show="active == 'left'" class="lottery-box-left">
                                <div class="draws-number">
                                    <div class="draws-number-content flex-between">
                                        <div class="draws-number-content-item">
                                            <img :src="staticState +'static/images/activity/blind/closeBox.svg'" alt="" />
                                            <p class="number" v-if="isLogin">
                                                {{
                              blindSummaryDetail ? blindSummaryDetail.available : "--"
                            }}/{{ blindSummaryDetail ? blindSummaryDetail.total : "--" }}
                                            </p>
                                            <p class="number" v-if="!isLogin">--/--</p>
                                            <!--剩余(我的)-->
                                            <span class="block">{{ $t("300129") }}</span>
                                        </div>
                                        <div class="draws-number-content-item">
                                            <img :src=" staticState +'static/images/activity/blind/openBox.svg' " alt="" />
                                            <p class="number">{{ isLogin && blindSummaryDetail ? blindSummaryDetail.amount : "--" }}</p>
                                            <!--已打开(总数USDT)-->
                                            <span class="block">{{ $t("300130") }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- </van-tab>
                <van-tab name="min" :title="$t('300079')"> -->
                            <div v-show="active == 'right'" class="awards-list">
                                <!--我的奖励-->
                                <div class="awards-list-content">
                                    <div class="table-head flex-between">
                                        <!--时间-->
                                        <span class="inline-block th" style="width:40%">{{ $t("300142") }}</span>
                                        <!-- 类型 -->
                                        <span class="inline-block th" style="width:26%">{{$t('300421')}}</span>
                                        <!--奖励-->
                                        <span class="inline-block th" style="width:33%">{{ $t("300131") }}</span>
                                    </div>
                                    <ul class="infinite-list" v-show="tableList.length > 0">
                                        <li v-for="(item, index) in tableList" :key="index + 'b'" class="infinite-list-item flex-between">
                                            <span class="inline-block td" style="width:40%">{{ parseTime(item.createTime) }}</span>
                                            <span class="inline-block td" style="width:26%">{{changeStatus(item)}}</span>
                                            <span class="inline-block td uppercase" style="width:33%">{{ item.amount }} {{ item.currency }}</span>
                                        </li>
                                    </ul>
                                    <p @click="showPopup" v-show="totalCount > 5" class="inline-block th">
                                        {{ $t("300089") }}
                                        <van-icon name="arrow" :class="isDirection ? 'mirrorRotateLevel' : ''" />
                                    </p>
                                    <div class="no-rank flex column" v-show="tableList.length == 0">
                                        <!--當前沒有任務-->
                                        <van-empty class="custom-image" :description="$t('300108')">
                                            <svg slot="image" class="icon" aria-hidden="true">
                                                <use xlink:href="#icon-zanwujilu"></use>
                                            </svg>
                                        </van-empty>
                                    </div>
                                </div>
                            </div>
                            <!-- </van-tab>
              </van-tabs> -->
                            <div class="rules-list">
                                <div class="rules-introduction">
                                    <!--玩法介绍-->
                                    <h1 :class="isDirection ? 'rtl' : 'ltr'" class="bold">{{ $t("300132") }}</h1>
                                    <!-- <h1 class="bold ">玩法介绍</h1> -->
                                    <div class="steps flex-between">
                                        <div class="step-item left">
                                            <i class="block normal">1</i>
                                            <!--邀请好友-->
                                            <p>{{ $t("300145") }}</p>
                                            <!--分享您的邀请链接-->
                                            <span class="block">{{ $t("300133") }}</span>
                                        </div>
                                        <div class="line left"></div>
                                        <div class="step-item center">
                                            <i class="block normal">2</i>
                                            <!--完成任务-->
                                            <p>{{ $t("300134") }}</p>
                                            <!--邀请好友注册,完成充值和交易任务-->
                                            <span class="block">{{ $t("300135") }}</span>
                                        </div>
                                        <div class="line right"></div>
                                        <div class="step-item step-right  right">
                                            <i class="block iconfont icon-lihe"></i>
                                            <!--领取盲盒-->
                                            <p>{{ $t("300136") }}</p>
                                            <!--达成任务,获取盲盒-->
                                            <span class="block">{{ $t("300137") }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="reward-currency" id="rewardCurrency">
                                    <!--盲盒奖励-->
                                    <p :class="isDirection ? 'rtl' : 'ltr'" class="label bold">{{ $t("300124") }}</p>
                                    <img class="block" v-if="isDirection" :src="staticState + 'static/images/activity/blind/coin-fan.png'" alt="" />
                                    <img class="block" v-if="!isDirection" :src="staticState + 'static/images/activity/blind/coin.png'" alt="" />
                                </div>
                                <div class="activity-rule">
                                    <!--活动规则-->
                                    <p :class="isDirection ? 'rtl' : 'ltr'" class="label bold">{{ $t("300140") }}</p>
                                    <div class="rule-content" v-html="ruleContent"></div>
                                    <van-empty v-show="!ruleContent" class="custom-image" :description="$t('300108')">
                                        <svg slot="image" class="icon" aria-hidden="true">
                                            <use xlink:href="#icon-zanwujilu"></use>
                                        </svg>
                                    </van-empty>
                                    <!-- <a class="block" v-show="ruleContent" :href="hrefMap[language]">{{ $t("300089") }}
                    <van-icon :name="isDirection ? 'arrow-left' : 'arrow'"/>
                  </a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 币种奖励 -->
        <div class="model" v-if="ifShowModel">
            <div class="lottery-model relative" :style="{ backgroundImage: 'url(' + backgroundGif + ')' }">
                <div :class="isDirection ? 'rtl' : 'ltr'" class="icon">
                    <van-icon @click="closeModel" name="cross" color="rgba(255,255,255,0.5)" />
                </div>
                <div class="award-amount absolute">
                    <span class="inline-block uppercase">{{resultObj ? "+" + resultObj.amount : ""}}{{ resultObj ? resultObj.currency : "" }}</span>
                </div>
                <div class="model-button absolute">
                    <van-button class="form-btn" @click="closeModel">{{ $t("300141") }}</van-button>
                </div>
            </div>
        </div>
        <!-- 抵扣券 -->
        <div class="model" v-if="ifShowModelCard">
            <div class="lottery-model relative" :style="{ backgroundImage: 'url(' + backgroundGif + ')' }">
                <div :class="isDirection ? 'rtl' : 'ltr'" class="icon">
                    <van-icon @click="closeModel" name="cross" color="rgba(255,255,255,0.5)" />
                </div>
                <div class="award-amount-card absolute">
                    <span class="inline-block">{{resultObj ? resultObj.amount : ""}}{{ resultObj ? resultObj.currency.toUpperCase() : "" }} {{ resultObj ? $t('300160') : '' }}</span>
                </div>
                <div class="model-button absolute">
                    <van-button class="form-btn" @click="closeModel">{{ $t("300141") }}</van-button>
                </div>
            </div>
        </div>

        <!-- <van-popup round :style="{ height: '10%',width:'60%',background:'#fff' }" v-model="show">{{content}}</van-popup> -->
        <van-popup v-model="tipsPopup" round class="tip-popup">
            <span><svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-tishi-1"></use>
                </svg></span>
            <p class="tip-message">{{content}}</p>
            <van-button class="form-btn" @click="tipsPopup = false">{{ $t("300141") }}</van-button>
        </van-popup>
        <van-popup class="tipdetail" v-model="show" position="left" teleport="body" closeable close-icon="arrow-left" close-icon-position="top-left" :style="{ height: '100%', width: '100%' }">
            <h3>{{ $t("300079") }}</h3>
            <van-list v-model="loading" :finished="finished" @load="onLoad" :offset="10">
                <div class="table-head flex-between">
                    <span class="inline-block th" style="width:43%;text-align:center">{{ $t("300142") }}</span>
                    <span class="inline-block th" style="width:33%;text-align:center">{{$t('300421')}}</span>
                    <span class="inline-block th" style="width:33%;text-align:center">{{ $t("300131") }}</span>
                </div>
                <ul class="infinite-list" v-show="itemList.length > 0">
                    <li v-for="(item, index) in itemList" :key="index + 'b'" class="infinite-list-item flex-between">
                        <span class="inline-block td" style="width:43%;text-align:center">{{ parseTime(item.createTime) }}</span>
                        <span class="inline-block td" style="width:33%;text-align:center">{{changeStatus(item)}}</span>
                        <span class="inline-block td uppercase" style="width:33%;text-align:center">{{ item.amount }} {{ item.currency }}</span>
                    </li>
                </ul>
            </van-list>
        </van-popup>
    </div>
</template>
<script>
import { Tabs, Button, Tag, Tab, Icon, Empty, Popup, Dialog, List } from 'vant'
import * as configs from '@/../config/config'
import { mapGetters } from 'vuex'
import { parseTime } from '../utils/index'
import { getUserInfo } from '../api/user'
import {
    setCookie,
    removeCookie,
    removeToken,
    getCookie,
    setToken,
} from '../utils/auth'
import {
    blindBoxInfo,
    blindSummary,
    awardsList,
    drawApi,
} from '../api/resource'
import openGif from '../assets/images/open.gif'
import openCardGif from '@/assets/images/openCardGif.gif'

export default {
    name: 'lottery',
    components: {
        vanButton: Button,
        vanTabs: Tabs,
        vanTab: Tab,
        vanTag: Tag,
        vanIcon: Icon,
        vanEmpty: Empty,
        vanPopup: Popup,
        vanDialog: Dialog,
        vanList: List,
    },

    data() {
        return {
            loading: false,
            finished: false,
            page: 1, //请求第几页
            pageSize: 10, //每页请求的数量
            total: 0, //总共的数据条数
            itemList: [],

            userInfo: {},
            isLogin: false, // 登录状态
            language: '',
            type: 'login',
            tipsPopup: false,
            show: false,
            content: '',
            isApp: '',
            startTime: null,
            endTime: null,
            status: 0,
            blindSummaryDetail: null,
            params: {
                page: 1,
                pageSize: 5,
            },
            tableList: [],
            tableListdetail: [],
            totalCount: 0,
            resultObj: null,
            ifShowModel: false,
            ifShowModelCard: false,
            backgroundGif: '',
            warnMessage: '',
            timer: null,
            ruleContent: '',
            active: 'left',
            staticState: configs[configs.Edition].staticState,
            hrefMap: {
                'zh-TC':
                    'https://support.superex.com/hc/zh-hk/articles/9132892683289',
                en: 'https://support.superex.com/hc/en-001/articles/9132892360473',
                ko: 'https://support.superex.com/hc/ko/articles/9132893561625',
                ja: 'https://support.superex.com/hc/en-001/articles/9132892360473',
                ru: 'https://support.superex.com/hc/ru/articles/9132892052505',
                fa: 'https://support.superex.com/hc/en-001/articles/9132892360473',
            },
        }
    },
    computed: {
        ...mapGetters(['isDirection', 'token']),
        isDisabled() {
            let condition1 = !this.startTime && !this.endTime // 活动下架
            let condition2 =
                this.startTime && this.startTime > new Date().getTime() // 活动暂未开始
            let condition3 = this.endTime && this.endTime < new Date().getTime() // 活动已结束
            let condition4 = !this.status // 活动关闭
            return condition1 || condition2 || condition3 || condition4
        },
    },
    watch: {
        $route() {
            this.resher()
        },
    },
    created() {
        this.resher()
    },
    methods: {
        changeStatus(item) {
            if (item.type === 1) {
                // 币种奖励
                return this.$t('300422')
            } else {
                // 抵扣券
                return this.$t('300175')
            }
        },
        changeTab(val) {
            this.active = val
        },
        parseTime(time, type) {
            if (time) {
                return parseTime(time, type)
            } else {
                return '--'
            }
        },
        goAppBack() {
            this.$jsBridge.callHandler(
                this.$jsBridgeCmd.goBack,
                {},
                (data) => {}
            )
        },
        goInvite() {
            if (this.isLogin) {
                this.$jsBridge.callHandler(
                    this.$jsBridgeCmd.goInvite,
                    { code: 200 },
                    (data) => {}
                )
            } else {
                if (this.isApp == 1) {
                    this.appLogin()
                    return false
                }
            }
        },
        showPopup() {
            this.show = true
            let params = {
                page: this.page,
                pageSize: this.pageSize,
            }
            awardsList(params).then((res) => {
                let rows = res.data.items //请求返回当页的列表
                this.loading = false
                this.total = res.data.total
                // this.tableListdetail = res.data.items || [];
                if (rows == null || rows.length === 0) {
                    // 加载结束
                    this.finished = true
                    return
                }

                // 将新数据与老数据进行合并
                this.itemList = this.itemList.concat(rows)
                if (this.itemList.length >= this.total) {
                    this.finished = true
                }
            })
        },
        onLoad() {
            this.page++
            this.showPopup()
        },
        getBlindBoxInfo() {
            blindBoxInfo().then((res) => {
                if (res.data) {
                    this.startTime = res.data.startTime
                    this.endTime = res.data.endTime
                    this.status = res.data.status
                    this.ruleContent = res.data.rule ? res.data.rule : ''
                    if (
                        (!res.data.startTime && !res.data.endTime) ||
                        (res.data.endTime &&
                            res.data.endTime < new Date().getTime())
                    ) {
                        this.warnMessage = this.$t('300138') // 本次活动已结束，敬请期待下一次活动！
                    } else if (
                        res.data.startTime &&
                        res.data.startTime > new Date().getTime()
                    ) {
                        this.warnMessage = this.$t('300139') // 本次活动暂未开始，敬请期待！
                    } else if (!res.data.status) {
                        this.warnMessage = ''
                    } else {
                        this.warnMessage = ''
                    }
                }
            })
        },
        handleOpenBlindBox() {
            if (!this.isLogin) {
                this.appLogin()
                return false
            } else {
                this.getDrawApi()
            }
        },
        getBlindSummary() {
            blindSummary().then((res) => {
                this.blindSummaryDetail = Object.assign({}, res.data)
            })
        },
        getAwardsList() {
            awardsList(this.params).then((res) => {
                this.tableList = res.data.items || []
                this.totalCount = res.data.total || 0
            })
        },
        closeModel() {
            this.ifShowModel = false
            this.ifShowModelCard = false
            this.getBlindSummary()
            this.params.page = 1
            this.params.pageSize = 5
            this.getAwardsList()
            clearTimeout(this.timer)
            this.resultObj = null
        },
        getDrawApi() {
            drawApi().then((res) => {
                if (res.data.code == 200) {
                    if (res.data.data.type === 1) {
                        //币种奖励
                        this.ifShowModel = true
                        this.backgroundGif =
                            openGif + '?+' + new Date().getTime()
                        clearTimeout(this.timer)
                        this.timer = setTimeout(() => {
                            this.resultObj = res.data.data
                        }, 2000)
                    } else {
                        this.backgroundGif =
                            openCardGif + '?+' + new Date().getTime()
                        this.ifShowModelCard = true
                        clearTimeout(this.timer)
                        this.timer = setTimeout(() => {
                            this.resultObj = res.data.data
                        }, 1500)
                    }
                } else if (res.data.code == 403 || res.data.code == 413) {
                    this.appLogout()
                } else {
                    this.tipsPopup = true
                    this.content = res.data.msg
                }
            })
        },
        appLogout() {
            var _this = this
            this.$jsBridge.callHandler(
                this.$jsBridgeCmd.appLogout,
                { code: 200 },
                (data) => {
                    _this.isLogin = false
                    removeToken()
                    removeCookie('userInfo')
                    _this.appLogin()
                }
            )
        },
        appLogin() {
            if (this.isApp == 1) {
                this.$jsBridge.callHandler(
                    this.$jsBridgeCmd.appLogin,
                    { code: 200, type: 'login' },
                    (data) => {}
                )
                return false
            }
        },
        getUserInfo() {
            getUserInfo().then((res) => {
                if (res.code == 403 || res.code == 413) {
                    this.appLogout()
                    return false
                }
                if (res.data) {
                    this.userInfo = res.data
                    setCookie('userInfo', JSON.stringify(res.data))
                }
            })
        },
        resher() {
            console.log(this.$route.query,'this.$route.query-this.$route.query');
            // Toast(this.$route.query.token ? '有token-测试用' : '没有token-测试用')
            this.isApp = this.$route.query.isApp
            var token = this.$route.query.token
            this.$store.dispatch(
                'setIsDirection',
                this.$route.query.language == 'fa' ? true : false
            )
            setCookie(
                'language',
                this.$route.query.language ? this.$route.query.language : 'en'
            )
            this.language = this.$route.query.language
                ? this.$route.query.language
                : 'en'
            window.document.documentElement.setAttribute(
                'dir',
                this.isDirection ? 'rtl' : 'ltr'
            )
            this.getBlindBoxInfo()
            if (this.isApp == 1) {
                this.$i18n.locale = this.language
                if (token) {
                    setToken(token)
                    this.isLogin = true
                    this.getUserInfo()
                    this.getBlindSummary()
                    this.getAwardsList()
                } else {
                    removeToken()
                    this.isLogin = false
                }
            } else {
                this.isLogin = getCookie('token') ? true : false
                if (this.isLogin) {
                    this.getUserInfo()
                    this.getBlindSummary()
                    this.getAwardsList()
                } else {
                    removeToken()
                }
            }
        },
    },
}
</script>
<style lang="scss" scoped>
@import '../assets/css/variableName';
@import '../style/mixin';

/deep/ .van-dialog__message {
    background: #1b1c1a;
    color: #fff;
}

.disabel {
    background-color: rgba(255, 255, 255, 0.1) !important;
    color: #ffffff66;
}
.lotteryMask {
    width: torem(160);
    height: torem(160);
    background: transparent;
    position: absolute;
    z-index: 99;
    top: torem(90);
    transform: translateX(-50%);
    left: 52%;
}
.tip-popup {
    text-align: center;
    padding-top: torem(10);
    background: #fff !important;
    .icon {
        margin: 0 auto;
        width: torem(48);
        height: torem(48);
    }
    .form-btn {
        font-weight: 600;
        font-size: torem(12);
        background: #ffc72b;
        width: torem(150);
        border-radius: torem(4);
        padding: 0;
        height: torem(30);
        margin: torem(10) auto;
        line-height: torem(30);
    }
    .tip-message {
        width: torem(260);
        padding: torem(12);
        height: auto;
        line-height: 1.5;
        font-size: torem(12);
        color: #000;
    }
}

.van-button--default {
    border: none;
}

/deep/ .van-tab {
    font-size: torem(14);
    line-height: 2;
}

.lottery-page {
    width: 100vw;
    height: 100vh;
    overflow-y: auto;
    position: fixed;
    top: 0;
    left: 0;
    background: linear-gradient(180deg, #1b1c1a 0%, #24252a 100%);

    .header-top {
        display: flex;
        justify-content: space-between;
        margin: 0 torem(17);
        background-color: #1b1c1a;

        .van-icon {
            color: #fff;
            font-size: torem(17);
        }

        .share-btn {
            color: #ffc72b;
            font-size: torem(14);
            line-height: 1;
        }
    }

    .lottery-main {
        width: 100%;
        min-height: torem(1600);
        -webkit-overflow-scrolling: touch;
        z-index: 1;
        height: auto;
        padding: torem(16) 0 torem(40);
        background: #1b1c1a;

        .lottery-container {
            .lottery-top {
                z-index: 10;
                margin-top: torem(25);
                padding: 0 torem(7);
                background-color: #1b1c1a;
            }

            margin: 0 auto;
            text-align: center;

            .h-title {
                margin-bottom: torem(16);
            }

            h1 {
                margin: 0;
                @include sc(torem(21), #fff);
                line-height: 1.3;
            }

            p {
                @include sc(torem(12), #ffffff99);
                margin-top: torem(16);
            }

            .lottery-box {
                height: 610px;
                margin: torem(64) 0 torem(48);

                .lottery-box-list {
                    margin-top: torem(-120);
                    width: 100%;
                    height: 100%;
                    background: url('../assets/images/close.gif') no-repeat
                        center;
                    background-size: 100% 100%;

                    .warn-message {
                        width: 100%;
                        text-align: center;
                        bottom: 300px;

                        span {
                            font-size: torem(12);
                            color: #f65d62;
                            padding: torem(8) torem(12);
                            background-color: rgba(246, 93, 98, 0.2);
                            border-radius: torem(2);
                            text-shadow: 2px 2px 4px #000;

                            i {
                                color: #f65d62;
                                font-size: torem(12);
                            }
                        }
                    }

                    .buttons {
                        bottom: torem(44);
                        width: 100%;
                        justify-content: center;

                        .open-btn {
                            width: torem(240);
                            height: torem(42);
                            line-height: 3;
                            font-weight: 600;
                            font-size: torem(14);
                            padding: 0 torem(10);
                            border-radius: torem(4);
                            background: #ffc72b;
                            position: absolute;
                            top: torem(-20);
                            opacity: 1;
                        }
                    }

                    .lottery-box-left {
                        padding: 0 torem(16);

                        .draws-number {
                            height: torem(155);
                            border-radius: torem(7);
                            margin-top: torem(12);

                            &-content {
                                width: 100%;
                                height: torem(141);
                                padding: torem(18) 0 torem(18);
                                background: rgba(255, 255, 255, 0.05);
                                border-radius: torem(7);

                                &-item {
                                    width: 50%;
                                    height: 100%;
                                    text-align: center;

                                    img {
                                        width: torem(60);
                                        margin: 0 auto;
                                    }

                                    p.number {
                                        margin: torem(12) 0;
                                        //font-family: D-DIN-Bold;
                                        font-size: torem(24);
                                        line-height: 1;
                                        color: #ffffff;
                                        letter-spacing: torem(1);
                                    }

                                    span.block {
                                        color: rgba(255, 255, 255, 0.6);
                                        line-height: 1;
                                        font-size: torem(12);
                                    }

                                    &:first-child {
                                        border-right: 1px solid
                                            rgba(255, 255, 255, 0.05);
                                    }
                                }
                            }
                        }
                    }
                }

                .lottery-item {
                    .lottery-tab {
                        display: flex;
                        justify-content: space-around;
                        div {
                            color: #fff;
                            font-size: torem(14);
                            padding: torem(5) 0;
                        }
                        .active {
                            color: #ffc72b;
                            border-bottom: torem(2) solid #ffc72b;
                        }
                        // .activeline {
                        //  width: torem(40);
                        //  height: torem(2);
                        //  background: #FFC72B;
                        //  margin-top: torem(5);
                        // }
                    }
                    margin-top: torem(334);

                    /deep/ .van-tabs__nav {
                        background: transparent;
                    }

                    .awards-list {
                        margin: torem(12) torem(16);

                        &-content {
                            width: 100%;
                            min-height: 300px;
                            max-height: 532px;
                            padding: torem(16) 0;
                            background-color: rgba(255, 255, 255, 0.05);
                            border-radius: torem(7);
                            overflow: auto;
                            .table-head {
                                padding: torem(7) torem(16);

                                span.th {
                                    font-size: torem(12);
                                    line-height: 1.5;
                                    color: rgba(255, 255, 255, 0.4);
                                }
                            }

                            .infinite-list {
                                .infinite-list-item {
                                    padding: torem(9) torem(16);
                                    color: #fff;
                                    font-size: torem(12);
                                    line-height: 1.5;
                                }
                            }

                            .no-rank {
                                /deep/ .van-empty__image {
                                     min-height: torem(80);
                                     height: auto;
                                     display: flex;
                                     flex-direction: column;
                                     align-items: center;
                                     //width:auto ;
                                     //min-width: torem(80);
                                    svg {
                                        width: torem(41);
                                        height: torem(41);
                                    }
                                }

                                /deep/ .van-empty__description {
                                    font-size: torem(10);
                                    color: #999;
                                    margin-top: torem(-36);
                                }
                            }
                        }
                    }

                    .rules-list {
                        margin-top: torem(24);
                        padding: 0 torem(16) torem(60);
                        background: #1b1c1a;
                        .rules-introduction {
                            width: 100%;
                            border: torem(2) solid rgba(255, 255, 255, 0.1);
                            border-radius: torem(8);
                            box-sizing: border-box;
                            padding: torem(24) torem(12);

                            h1 {
                                margin: 0 auto;
                                padding: 0 10px;
                                font-size: torem(14);
                                color: #fff;
                                width: fit-content;
                            }

                            h1.ltr {
                                background: url('#{$variableName}static/images/activity/blind/titleBg.png')
                                    no-repeat left 90%;
                                background-size: torem(86) torem(9);
                            }

                            h1.rtl {
                                background: url('#{$variableName}static/images/activity/blind/titleBgFan.png')
                                    no-repeat right 70%;
                                background-size: torem(86) torem(9);
                            }

                            .steps {
                                margin-top: torem(20);
                                position: relative;
                                align-items: flex-start;

                                .step-right {
                                    p {
                                        margin-top: torem(17) !important;
                                    }
                                }

                                .step-item {
                                    width: 33%;

                                    i.normal {
                                        font-size: torem(12);
                                        width: torem(24);
                                        height: torem(24);
                                        line-height: 2;
                                        text-align: center;
                                        border-radius: 50%;
                                        border: 1px solid #fff;
                                        color: #fff;
                                    }

                                    i.iconfont {
                                        font-size: torem(24);
                                        color: #fff;
                                    }

                                    p {
                                        color: #fff;
                                        font-size: torem(12);
                                        margin: torem(12) 0 torem(5);
                                        line-height: 1;
                                    }

                                    span {
                                        color: #999;
                                        font-size: torem(10);
                                        line-height: 1.5;
                                    }
                                }

                                .step-item.left {
                                    text-align: start;
                                }

                                .step-item.center {
                                    text-align: center;

                                    i {
                                        margin: 0 auto;
                                    }
                                }

                                .step-item.right {
                                    text-align: end;
                                }

                                .line {
                                    box-sizing: border-box;
                                    margin: 0;
                                    min-width: 0;
                                    position: absolute;
                                    width: calc(50% - 70px);
                                    // max-width: 450px;
                                    border-top: 1px solid rgb(255, 255, 255);
                                    top: torem(10);
                                }

                                .line.left {
                                    left: torem(24);
                                }

                                .line.right {
                                    right: torem(24);
                                }
                            }
                        }

                        .reward-currency {
                            width: 100%;
                            border: torem(2) solid rgba(255, 255, 255, 0.1);
                            border-radius: torem(7);
                            box-sizing: border-box;
                            padding: torem(24) torem(12) torem(32);
                            margin-top: torem(24);
                            // background-color: #24252a;
                            p.label {
                                margin: 0 auto torem(18);
                                padding: 0 10px;
                                font-size: torem(14);
                                color: #fff;
                                width: fit-content;
                            }

                            p.label.rtl {
                                background: url('#{$variableName}static/images/activity/blind/titleBgFan.png')
                                    no-repeat right 70%;
                                background-size: torem(86) torem(9);
                            }

                            p.label.ltr {
                                background: url('#{$variableName}static/images/activity/blind/titleBg.png')
                                    no-repeat left 90%;
                                background-size: torem(86) torem(9);
                            }

                            img.block {
                                margin: 0 auto;
                                width: 100%;
                            }
                        }

                        .activity-rule {
                            width: 100%;
                            border: torem(2) solid rgba(255, 255, 255, 0.1);
                            border-radius: torem(7);
                            box-sizing: border-box;
                            padding: torem(24) torem(12) torem(32);
                            margin-top: torem(24);

                            p.label {
                                margin: 0 auto torem(18);
                                padding: 0 10px;
                                font-size: torem(14);
                                color: #fff;
                                width: fit-content;
                            }

                            p.label.rtl {
                                background: url('#{$variableName}static/images/activity/blind/titleBgFan.png')
                                    no-repeat right 70%;
                                background-size: torem(86) torem(9);
                            }

                            p.label.ltr {
                                background: url('#{$variableName}static/images/activity/blind/titleBg.png')
                                    no-repeat left 90%;
                                background-size: torem(86) torem(9);
                            }

                            .rule-content {
                                text-align: start;
                                color: #999;
                                font-size: torem(12);
                                line-height: 1.5;
                            }

                            /deep/ .van-empty__image {
                                svg {
                                    width: torem(41);
                                    height: torem(41);
                                }
                            }

                            /deep/ .van-empty__description {
                                margin-top: torem(-36);
                            }

                            a {
                                margin-top: torem(36);
                                font-size: torem(12);

                                i {
                                    font-size: torem(12);
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .model {
        box-sizing: border-box;
        margin: 0;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        z-index: 1000;
        position: fixed;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.25);

        .lottery-model {
            width: torem(345);
            height: torem(325);
            box-sizing: border-box;
            border-radius: torem(7);
            background-position: center;
            // background-size: 101% 101%;
            background-size: cover;
            background-repeat: no-repeat;
            background-color: #000;

            div.rtl {
                position: absolute;
                right: torem(320);
                top: torem(14);
                color: rgba(255, 255, 255, 0.5);
                font-size: torem(14);
                z-index: 1200;
            }
            div.ltr {
                position: absolute;
                left: torem(320);
                top: torem(14);
                color: rgba(255, 255, 255, 0.5);
                font-size: torem(14);
                z-index: 1200;
            }
            .award-amount {
                bottom: torem(250);
                text-align: center;
                width: 100%;

                span {
                    font-size: torem(41);
                    line-height: torem(41);
                    margin: 0;
                    background: linear-gradient(
                        270deg,
                        #ffa800 0%,
                        #fff27e 41%,
                        #ffa800 100%
                    );
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    direction: ltr;
                }
            }
            .award-amount-card{
                bottom: torem(250);
                text-align: center;
                width: 100%;
                height: 3.2rem;
                span {
                    max-width: torem(280);
                    font-size: torem(16);
                    line-height: torem(28);
                    // margin: 0;
                    background: linear-gradient(
                        270deg,
                        #ffa800 0%,
                        #fff27e 41%,
                        #ffa800 100%
                    );
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    direction: ltr;
                }
            }
            .model-button {
                width: 100%;
                bottom: torem(22);
                text-align: center;

                .form-btn {
                    font-weight: 600;
                    font-size: torem(14);
                    background: #ffc72b;
                    width: torem(209);
                    border-radius: torem(4);
                    padding: 0;
                    height: torem(44);
                    line-height: torem(42);
                }
            }
        }
    }

    .van-popup {
        background: #1b1c1a;

        /deep/ .van-icon {
            font-size: torem(18);
            color: #fff;
            margin-top: torem(12);
        }

        .van-popup__close-icon {
            font-size: torem(18);
        }

        h3 {
            margin: torem(20) 0 torem(18);
            text-align: center;
            color: #fff;
            font-size: torem(18);
            padding-left: torem(14);
        }

        .table-head {
            padding: torem(7) torem(16);

            span.th {
                font-size: torem(12);
                line-height: 1.5;
                color: rgba(255, 255, 255, 0.4);
            }
        }

        .infinite-list {
            .infinite-list-item {
                padding: torem(9) torem(16);
                color: #fff;
                font-size: torem(12);
                line-height: 1.5;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/lottery.vue